export default __webpack_public_path__ + "static/media/chicken-1.c6be6eae.png";